import { getUuidTypesByCompany } from "../../helpers/fetching";

export default {
  state: {
    data: {},
    loading: false,
    error: null,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setUuidTypesByCompany(state, data) {
      state.data = data;
    },
    setUuidTypesByCompanyLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setUuidTypeByCompanyResponse(state, data) {
      state.response = data;
    },
    setResetUuidTypesByCompany(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
    },
    setCustomerError(state, data) {
      state.loading = false;
      state.error = data;
    },
  },
  actions: {
    fetchUuidTypesByCompany({ commit }, value) {
      return new Promise((resolve) => {
        commit("setUuidTypesByCompanyLoading", true);
        getUuidTypesByCompany(value)
          .then((response) => {
            commit("setUuidTypesByCompany", response);
            commit("setUuidTypesByCompanyLoading", false);
            resolve();
          })
          .catch((error) => {
            commit("setCustomerError", error);
            resolve();
          });
      });
    },
    resetCustomerData({ commit }) {
      commit("setResetUuidTypesByCompany");
    },
  },
};
